export const HttpServer = {
    apiServerHost: 'http://betx.tips:3030',
    apiAuthentication: '/App_WebServices/AuthService.asmx/RequestAuth',
    apiAuthorization: '/App_WebServices/AuthService.asmx/Auth',
    apiLogout: '/App_WebServices/AuthService.asmx/Logout',
    apiElectionPolls: '/App_WebServices/ElectionService.asmx/GetElectionPolls',
    apiCitizens: '/App_WebServices/ElectionService.asmx/GetElectionCitizens',
    apiVote: '/App_WebServices/ElectionService.asmx/SetVoted',
    apiAuthorizedVote: '/App_WebServices/ElectionService.asmx/SetAuthVoted',
    apiVoteAuthorization: '/App_WebServices/ElectionService.asmx/RequestAuth',
    apiVoted: '/App_WebServices/ElectionService.asmx/GetVoted',
    apiElectionResultFormConfig: '/App_WebServices/ElectionService.asmx/ResultFormConfig',
    apiElectionSetResultForm: '/App_WebServices/ElectionService.asmx/SetResultForm',
    apiElectionSetCandidateResults: '/App_WebServices/ElectionService.asmx/SetCandidateResults',

    apiUsers: '/user',
    apiAgents: '/agents',
    apiClients: '/clients'

}
